import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { Navigation } from './Navigation'
import { Header } from './Header'
import { OfflineIndicator } from './OfflineIndicator'

export function AppLayout() {
  const { isAuthenticated, isLoading } = useAuthStore()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-700 mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <div className="flex pt-16">
        <Navigation />
        <main className="flex-1 p-3 sm:p-4 lg:p-6 lg:ml-64">
          <Outlet />
        </main>
      </div>
      <OfflineIndicator />
    </div>
  )
}
